import { Pixall, Google } from '../analytics/index.js';

/**
 * @summary Sends GA and Pixall event for Find That Car cta
 * @events event12
 */

export async function findThatCarCtaClick(_ref, option) {
  let {
    dataLayer
  } = _ref;
  const pixallData = {
    pageType: 'marketing',
    eventSource: 'button',
    eventType: 'click',
    pageId: 'markt_lnd',
    label: 'cta::srp::find-that-car',
    hasListingType: false
  };
  Pixall.sendClickEvent(pixallData, dataLayer, option);
  Google.sendClickEvent({
    eventElement: 'search-car',
    eventResult: 'cta::find-that-car',
    eventAction: 'search',
    eventNonInteractive: false,
    eventData: {}
  }, option);
  return {};
}
export default {
  findThatCarCtaClick
};